import type { FC } from 'react';
import { Icon } from '@iconify/react';
import { Box, IconButton, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { SentryButton } from 'src/components/sentry-button';
import { AccountButton } from '../account/account-button';
import { SIDE_NAV_WIDTH, TOP_NAV_HEIGHT } from '../config';

const HeaderContainer = styled('header', {
  shouldForwardProp: (prop: string) => !['mobile'].includes(prop)
})<{ mobile: boolean }>(({ theme, mobile }) => ({
  backdropFilter: 'blur(6px)',
  backgroundColor: alpha(theme.palette.background.default, 0.8),
  position: 'sticky',
  top: 0,
  minHeight: TOP_NAV_HEIGHT,
  zIndex: theme.zIndex.appBar,

  // align content
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: theme.spacing(0, 2),
  gap: theme.spacing(1),

  // align to navigation drawer
  ...(!mobile && {
    left: `${SIDE_NAV_WIDTH}px`,
    width: `calc(100% - ${SIDE_NAV_WIDTH}px)`,
    gap: theme.spacing(2)
  })
}));

interface HeaderProps {
  mobile?: boolean;
  onNavigationOpen?: () => void;
}

export const Header: FC<HeaderProps> = (props) => {
  const { mobile, onNavigationOpen } = props;

  return (
    <HeaderContainer mobile={!!mobile}>
      {mobile && (
        <IconButton
          color="inherit"
          onClick={onNavigationOpen}
        >
          <Icon
            icon="fa6-solid:bars"
            style={{ fontSize: 'subtitle2.fontSize' }}
          />
        </IconButton>
      )}
      <Box flexGrow={1} />
      <SentryButton />
      <AccountButton />
    </HeaderContainer>
  );
};
